import Vue from 'vue';
import Vuex from 'vuex';

import auth from "./modules/auth";
import alerts from "./modules/alerts-module";
import profile from "./modules/profile-module";
import users from "./modules/users-module";
import roles from "./modules/roles-module";
import categories from "./modules/categories-module";
import tags from "./modules/tags-module";
import items from "./modules/items-module";

import functions from "@/store/modules/functions-module";

import clients from "@/store/modules/clients-module";
import sectors from "@/store/modules/sectors-module";
import activities from "@/store/modules/activities-module";
import insects from "@/store/modules/insects-module";
import contacts from "@/store/modules/contacts-module";
import sites from "@/store/modules/sites-module";
import site_documents from "@/store/modules/site-documents-module";
import documents from "@/store/modules/documents-module";
import devices from "@/store/modules/devices-module";
import deviceGroups from "@/store/modules/device-groups-module";
import deviceReportTypes from "@/store/modules/device/device-report-types-module";
import absences from "@/store/modules/absences-module";
import contracts from "@/store/modules/contracts-module";
import interventionReports from "./modules/planning/intervention-reports-modules";
import interventionTypes from "@/store/modules/planning/intervention-types-module";
import products from "@/store/modules/products-module";
import interventionPlans from "@/store/modules/planning/intervention-plans-module";
import interventions from "@/store/modules/planning/interventions-module";
import planningManagement from "@/store/modules/planning/management-module";
import bills from "./modules/bills-modules";
import calendar from "@/store/modules/planning/calendar-module";
import calendarTransfer from "@/store/modules/planning/calendar-transfer-module";
import stats from "@/store/modules/stats-module";

// intervention Validations
import interventionValidations from "./modules/planning/intervention-validations";

// Demands
import demands from "@/store/modules/demands-module";
import demandTypes from "@/store/modules/demand-types-module";
import demandComments from "@/store/modules/demand-comments-module";
import demandTasks from "@/store/modules/demands/demand-tasks-module";

/********* Clients Area *********/
import caAuth from "./modules/caAuth"
import clientArea from "@/store/modules/clients-area/clientArea-module"

/********* Progressive Web App *********/
import pwaAuth from "./modules/pwa/auth"
import pwaPlanning from "./modules/pwa/planning-module";
import pwaDevice from "./modules/pwa/device-module";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        functions,
        auth,
        alerts,
        profile,
        users,
        roles,
        categories,
        tags,
        items,
        clients,
        sectors,
        activities,
        insects,
        contacts,
        caAuth,
        clientArea,
        documents,
        sites,
        site_documents,
        devices,
        deviceGroups,
        deviceReportTypes,
        products,
        contracts,
        absences,
        interventionReports,
        interventionTypes,
        interventionPlans,
        interventions,
        planningManagement,
        demands,
        demandTypes,
        demandComments,
        demandTasks,
        bills,
        calendar,
        calendarTransfer,
        pwaAuth,
        pwaPlanning,
        pwaDevice,
        interventionValidations,
        stats
    }
});
